import { useState, PropsWithChildren } from 'react';
import { ModalContext, ModalContextState } from './context';

export function ModalContextProvider<T = any>({
  children,
}: PropsWithChildren<Record<string, unknown>>) {
  const [modalState, showModal] = useState<T | null>(null);
  const hideModal = () => showModal(null);

  const state: ModalContextState<T> = {
    modalState,
    showModal,
    hideModal,
  };

  return <ModalContext.Provider value={state}>{children}</ModalContext.Provider>;
}
